import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { PreviousQuestionId } from '../previous-question-id';
import { QuestionType } from '../question-type';
export var Questions = /*#__PURE__*/function () {
  function Questions() {
    _classCallCheck(this, Questions);
  }

  _createClass(Questions, null, [{
    key: "getQuestionIndex",
    value: function getQuestionIndex(previousQuestion) {
      var index;

      if (previousQuestion) {
        index = previousQuestion.type === QuestionType.FillInBlank || previousQuestion.type === QuestionType.Matching ? previousQuestion.nextIndex : previousQuestion.index + 1;
      } else {
        index = 1;
      }

      return index;
    }
  }, {
    key: "addIndex",
    value: function addIndex(questions) {
      var _this = this;

      return questions.map(function (q) {
        var previousQuestion = questions.find(function (question) {
          return question.id.toString() === q.previousQuestionId;
        });

        var index = _this.getQuestionIndex(previousQuestion);

        if (q.type === QuestionType.FillInBlank) {
          q.addIndex(index);
          q.addNextIndex(index + q.answers.length);
          return q;
        }

        if (q.type === QuestionType.Matching) {
          q.addIndex(index);
          q.addNextIndex(index + q.subQuestions.length);
          return q;
        }

        q.addIndex(index);
        q.addNextIndex(index + 1);
        return q;
      });
    }
  }, {
    key: "sortQuestions",
    value: function sortQuestions(questions) {
      if (questions.length === 0) {
        return [];
      }

      if (questions.length === 1) {
        return this.addIndex(questions);
      }

      var sortedQuestions = [];
      var usedIds = new Set();
      var headQuestion = questions.find(function (question) {
        return question.previousQuestionId === PreviousQuestionId.none.id.toString();
      });

      if (headQuestion) {
        sortedQuestions.push(headQuestion);
        usedIds.add(headQuestion.id.toString());
      }

      var currentQuestionId = headQuestion === null || headQuestion === void 0 ? void 0 : headQuestion.id.toString();
      questions.forEach(function () {
        var nextQuestion = questions.find(function (question) {
          var _question$previousQue;

          return ((_question$previousQue = question.previousQuestionId) === null || _question$previousQue === void 0 ? void 0 : _question$previousQue.toString()) === currentQuestionId && !usedIds.has(question.id.toString());
        });

        if (!nextQuestion) {
          return;
        }

        sortedQuestions.push(nextQuestion);
        usedIds.add(nextQuestion.id.toString());
        currentQuestionId = nextQuestion.id.toString();
      }); // Keep unreachable questions (broken links) instead of dropping them from UI/Redux.

      questions.forEach(function (question) {
        var id = question.id.toString();

        if (!usedIds.has(id)) {
          sortedQuestions.push(question);
          usedIds.add(id);
        }
      });
      return this.addIndex(sortedQuestions);
    }
    /**
     * Discover section order by walking the global previousQuestionId chain.
     * Falls back to Map insertion order for sections not reached by the chain.
     */

  }, {
    key: "getSectionOrderFromQuestionLinks",
    value: function getSectionOrderFromQuestionLinks(questions, mapSections) {
      var order = [];
      var seenSections = new Set();
      var usedQuestionIds = new Set();
      var headQuestion = questions.find(function (question) {
        return question.previousQuestionId === PreviousQuestionId.none.id.toString();
      });
      var currentQuestionId = headQuestion === null || headQuestion === void 0 ? void 0 : headQuestion.id.toString();
      questions.forEach(function () {
        if (!currentQuestionId || usedQuestionIds.has(currentQuestionId)) {
          return;
        }

        usedQuestionIds.add(currentQuestionId);
        var current = questions.find(function (question) {
          return question.id.toString() === currentQuestionId;
        });

        if (!current) {
          return;
        }

        var sectionId = current.sectionId.toString();

        if (!seenSections.has(sectionId)) {
          seenSections.add(sectionId);
          order.push(sectionId);
        }

        var nextQuestion = questions.find(function (question) {
          var _question$previousQue2;

          return ((_question$previousQue2 = question.previousQuestionId) === null || _question$previousQue2 === void 0 ? void 0 : _question$previousQue2.toString()) === currentQuestionId && !usedQuestionIds.has(question.id.toString());
        });
        currentQuestionId = nextQuestion === null || nextQuestion === void 0 ? void 0 : nextQuestion.id.toString();
      });
      mapSections.forEach(function (_, sectionId) {
        if (!seenSections.has(sectionId)) {
          order.push(sectionId);
        }
      });
      return order;
    }
    /**
     * Orders questions by section and assigns continuous indices across the form
     * (Section 1: 1–n, Section 2: n+1–…), including multi-slot FIB/Matching weights.
     *
     * @param orderedSectionIds Prefer UI section order (e.g. sectionSummaries). When omitted,
     * section order is inferred from the global previousQuestionId chain — never from Map
     * insertion order, which can renumber later sections starting at 1.
     */

  }, {
    key: "sortQuestionsWithIndexAndSection",
    value: function sortQuestionsWithIndexAndSection(questions, orderedSectionIds) {
      var _this2 = this;

      if (questions.length === 0) {
        return [];
      }

      var mapSections = new Map(); // eslint-disable-next-line no-loops/no-loops

      var _iterator = _createForOfIteratorHelper(questions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _question = _step.value;

          var sectionId = _question.sectionId.toString();

          if (mapSections.has(sectionId)) {
            mapSections.get(sectionId).push(_question);
          } else {
            mapSections.set(sectionId, [_question]);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var sectionOrder = orderedSectionIds && orderedSectionIds.length > 0 ? [].concat(_toConsumableArray(orderedSectionIds.filter(function (id) {
        return mapSections.has(id);
      })), _toConsumableArray(Array.from(mapSections.keys()).filter(function (id) {
        return !orderedSectionIds.includes(id);
      }))) : this.getSectionOrderFromQuestionLinks(questions, mapSections);
      var sortedQuestions = [];
      sectionOrder.forEach(function (sectionId) {
        var sectionQuestions = mapSections.get(sectionId);

        if (sectionQuestions !== null && sectionQuestions !== void 0 && sectionQuestions.length) {
          sortedQuestions.push.apply(sortedQuestions, _toConsumableArray(_this2.sortQuestions(sectionQuestions)));
        }
      });
      var weightOfIndex = 1;
      var newSortedQuestions = []; // eslint-disable-next-line no-loops/no-loops

      for (var index = 0; index < sortedQuestions.length; index++) {
        var question = sortedQuestions[index];
        var weight = this.getQuestionCount(question) || 1;
        question.addIndex(weightOfIndex);
        question.addNextIndex(weightOfIndex + weight);
        weightOfIndex += weight;
        newSortedQuestions.push(question.clone());
      }

      return newSortedQuestions;
    }
  }, {
    key: "hasEssayOrFillInBlankQuestion",
    value: function hasEssayOrFillInBlankQuestion(questions) {
      return questions.some(function (q) {
        return q.type === QuestionType.Essay || q.type === QuestionType.FillInBlank;
      });
    }
  }, {
    key: "getQuestionCount",
    value: function getQuestionCount(question) {
      var _answers$length, _answers, _subQuestions$length, _subQuestions;

      switch (question.type) {
        case QuestionType.FillInBlank:
          return (_answers$length = (_answers = question.answers) === null || _answers === void 0 ? void 0 : _answers.length) !== null && _answers$length !== void 0 ? _answers$length : 0;

        case QuestionType.Matching:
          return (_subQuestions$length = (_subQuestions = question.subQuestions) === null || _subQuestions === void 0 ? void 0 : _subQuestions.length) !== null && _subQuestions$length !== void 0 ? _subQuestions$length : 0;

        default:
          return 1;
      }
    }
  }, {
    key: "getTotalQuestions",
    value: function getTotalQuestions() {
      var _this3 = this;

      var questions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return questions.reduce(function (sum, question) {
        return sum + _this3.getQuestionCount(question);
      }, 0);
    }
  }, {
    key: "getTotalScore",
    value: function getTotalScore() {
      var questions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return questions.reduce(function (sum, question) {
        return sum + (Number(question.score) || 0);
      }, 0);
    }
  }]);

  return Questions;
}();